<template lang="html">
  <div :class="['coupon-code', 'flex-box', 'vertically-at-top', 'wrap', klass]">
    <SymbiumFormGroup
      label="Add a promo code (optional)"
      placeholder="Code (optional)"
      v-bind:value.sync="couponCode" 
      @update:value="onCouponCodeChange"
      :iconClass="loading ? 'loading' : actionText"
      :disabled="applied"
      :error="error"
      :loading="loading"
      :onIconClick="() => applyCouponCode()"
      :inputSize="inputSize"
    />
    <div class="spinner" v-if="loading">
      <Spinner />
    </div>
    <div class="gap-8">{{message}}</div>
  </div>
</template>

<script>
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import Spinner from 'src/components/common/Spinner.vue'
import EventBus from 'src/components/EventBus.js'

export default {
  data() {
    return {
      couponCode: this.givenCouponCode,
      applied: false,
      loading: false,
      error: null,
      message: null,
    }
  },
  props: ['klass', 'amount', 'givenCouponCode', 'inputSize'],
  components: { Spinner, SymbiumFormGroup },
  computed: {
    actionText() {
      return this.applied ? 'Cancel' : 'Apply';
    },
    actionTextClass() {
      var loadingClass = this.loading ? 'loading' : '';
      return (this.couponCode ? 'action-text' : 'action-text inactive') + ' ' + loadingClass;
    }
  },
  methods: {
    onCouponCodeChange(value) {
      this.couponCode = value;
      this.error = null
    },
    applyCouponCode(givenAmount) {
      if(!this.couponCode) return;

      if (this.applied && !givenAmount) {
        this.couponCode = null;
        this.applied = false;
        this.error = null;
        this.message = null;
        EventBus.$emit('coupon-applied', { discount: 0 })
        return;
      }

      this.loading = true
      var amount = givenAmount || this.amount || this.$cart.annualCostInUsd(this.$questionnaire)
      this.$coupon.checkCoupon(
        this.couponCode,
        amount,
        this.applyCoupon,
        this.showError
      )
    },
    applyCoupon(data) {
      EventBus.$emit('coupon-applied', data)
      this.message = `$${data.discount} savings for first year`
      this.applied = true;
      this.loading = false;
    },
    showError(data) {
      this.error = data.error
      this.applied = true;
      this.loading = false;
    },
    costChanged(cost) {
      this.applyCouponCode(cost)
    }
  },
  created(){
    EventBus.$on('cost-changed', this.costChanged)
  },
  beforeDestroy(){
    EventBus.$on('cost-changed', this.costChanged)
  }
}
</script>

<style lang="scss" scoped>
.coupon-code {
  position: relative;

  .spinner {
    position: absolute;
    top: 42px;
    left: 280px;
  }
}
</style>
